'use strict';

class ChallengesParticipantsController {
  constructor($rootScope,
              $scope,
              $filter,
              $state,
              utils,
              config,
              ChallengesService,
              PermissionsService) {

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';

    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.currentUser = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);
    $scope.challengeId = $state.params && $state.params.id;

    $scope.timeFormatStr = $t('datetime.mdyHM12');

    $scope.searchVal = '';
    $scope.sortCol = 'name';
    $scope.sortBy = ['firstname', 'lastname', 'email.email'];
    $scope.sortReverse = true;
    $scope.participantStatuses = config.getConfigByKey('participantStatuses');

    $scope.loading = true;

    angular.extend($scope, {
      editLocation: editLocation,
      getLocationDevices: getLocationDevices,
      canEditLocation: canEditLocation
    });

    function initPage() {
      getParticipants();
    };

    $scope.toggleFilter = function() {
      $('#filter').transition('fade down');
    };

    // Save filter and init filter begin
    let filterKey = 'Filter-Challenges-Pariticipants-' + $scope.challengeId;
    $scope.cacheFilter = false;
    $scope.saveFilter = function() {
      if ($scope.cacheFilter) { //cache filter
        let params = {
          searchVal: $scope.searchVal,
          status: $scope.status
        };
        utils.setStorageItem(filterKey, params);
      } else { //remove filter
        utils.removeStorageItem(filterKey);
      }
    };

    function getLocationDevices(location) {
      if (!location || !location.devices) {
        return;
      }
      let str = '';
      location.devices.forEach((device, index) => {
        if (!device.desc) {
          device.desc = $t('common.unknownDevice');
        }
        str += device.desc + ' (' + device.type + ')';
        str += index < (location.devices.length - 1) ? ', ' : '';
      });
      return str;
    }

    function canEditLocation(location) {
      if (!location) {
        return false;
      }
      return PermissionsService.canIEditLocation(location);
    }

    $scope.initFilterFromCache = function() {
      let params = utils.getStorageItem(filterKey);
      if (params) {
        $scope.cacheFilter = true;
        $scope.searchVal = params.searchVal;
        $scope.status = params.status;
      } else {}
    };
    //init filter
    $scope.initFilterFromCache();

    $scope.$watchGroup([
      'cacheFilter',
      'searchVal',
      'status'
    ], function() {
      $scope.saveFilter();
    });
    //save filter and init filter end

    $scope.resetFilter = function() {
      $scope.loading = true;
      $scope.searchVal = '';
      $scope.status = null;
      getParticipants();
    };

    $scope.filterParticipants = function() {
      getParticipants();
    };

    $scope.sortParticipants = function(event, colName) {
      if ('status' == colName) {
        $scope.sortBy = ['participationStatus'];
      } else if ('devices' == colName) {
        return;
      } else if ('name' == colName) {
        $scope.sortBy = ['firstname', 'lastname', 'email.email'];
      } else {
        return;
      }
      $scope.sortCol = colName;
      $scope.sortReverse = !$scope.sortReverse;
    };

    function editLocation(location) {
      if ($scope.loading || !canEditLocation(location)) {
        return;
      }
      location.organizationId = $scope.orgInfo.id;
      utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, location);
      $state.go('main.locations.edit');
    }

    function getParticipants() {
      let params = {};
      if ($scope.status != null) {
        params.status = $scope.status;
      }
      return ChallengesService.getChallengeParticipants($scope.orgInfo.id, $scope.challengeId, params)
        .then(function(data) {
          $scope.loading = false;
          $scope.participants = data.locations;
          //console.info($scope.participants);
          return data;
        }, err => {
          console.info(err);
          $scope.loading = false;
        });
    }

    initPage();
  }
}

export default angular
  .module('main.challenges.participants.controller', [])
  .controller('ChallengesParticipantsController', ChallengesParticipantsController)
  .name;
